module.exports = __webpack_public_path__ + "img/th.194a8d8f.svg";